import { selectBillingUserType } from '../../../reducers/v2/user/selectors';
import { EPaymentInitSource } from '../../../../PaymentWidgetMicrofrontend';
import { ERecommendedPackageType } from '../../../types/reducers/recommendedPackages';
import { TThunkAction } from '../../../../common/types/thunk';
import { mapBuyCustomPackageData, mapBuyPackageData } from './utils';
import { selectActiveRecommendedPackage } from '../../../reducers/v2/recommendedPackages/selectors';

export const buyPackageThunk =
  (): TThunkAction =>
  (_, getState, { payPackageMicrofrontend }) => {
    const state = getState();
    const billingUserType = selectBillingUserType(state)!;
    const recommendedPackage = selectActiveRecommendedPackage(state)!;

    const paymentInitSource = EPaymentInitSource.AddFormDeposit;

    if (recommendedPackage.packageType === ERecommendedPackageType.Custom) {
      const packageData = mapBuyCustomPackageData(recommendedPackage);

      payPackageMicrofrontend?.buyCustomPackage({ packageData, billingUserType, paymentInitSource });
    } else {
      const packageData = mapBuyPackageData(recommendedPackage);

      payPackageMicrofrontend?.buyPackage({ packageData, billingUserType, paymentInitSource });
    }
  };
